/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Analytics Reports API
 * API для генерации PDF/XLSX отчетов по аналитике медицинских клиник.

Все отчеты генерируются асинхронно в фоновом режиме. 
После создания задачи вы получаете `jobId` (UUID), по которому можно отслеживать статус и скачать готовый файл.

**Типы отчетов:**
- Общие показатели
- KPI по записям
- Подтверждение записи
- Отмена записи
- Статистика по виджету
- Статистика по отзывам
- Статистика по источникам записей

 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod"

/**
 * Возвращает список всех бизнесов (клиник), к которым у пользователя есть доступ.

**Использование:**
- Для фильтров в UI (выбор бизнеса)
- Определение доступных данных для пользователя

**Авторизация:**
Из JWT токена извлекается user_id, по которому определяются доступные бизнесы.

 * @summary Получить доступные бизнесы пользователя
 */
export const GetUserBusinessesResponse = zod
	.object({
		businesses: zod
			.array(
				zod
					.object({
						internalID: zod
							.string()
							.describe("Уникальный идентификатор бизнеса"),
						showLeadsScreen: zod
							.boolean()
							.describe(
								"Whether the Leads feature is enabled for this business",
							),
						acl: zod
							.array(zod.string())
							.describe("Exact business-scoped backoffice operations"),
						name: zod.string().describe("Название бизнеса"),
						address: zod
							.object({
								locality: zod.string().describe("Город\/населенный пункт"),
								street: zod.string().describe("Название улицы"),
								streetType: zod.string().describe("Тип улицы"),
								number: zod.string().describe("Номер дома"),
								address: zod.string().describe("Полный адрес"),
							})
							.describe("Адрес бизнеса"),
						timezone: zod
							.string()
							.optional()
							.describe("Часовой пояс бизнеса (IANA, например Europe\/Moscow)"),
					})
					.describe("Информация о бизнесе (клинике)"),
			)
			.describe("Массив доступных бизнесов"),
		acl: zod.array(zod.string()).describe("Список ACL разрешений пользователя"),
	})
	.describe("Список бизнесов пользователя")

/**
 * Возвращает профиль текущего пользователя с основными данными.

**Авторизация:**
Из JWT токена извлекается user_id, по которому определяется профиль пользователя.

 * @summary Получить профиль пользователя
 */
export const GetUserProfileResponse = zod
	.object({
		profile: zod
			.object({
				name: zod.string().describe("Имя пользователя"),
				surname: zod.string().describe("Фамилия пользователя"),
				middleName: zod.string().describe("Отчество пользователя"),
				email: zod.string().describe("Email пользователя"),
			})
			.describe("Данные профиля пользователя"),
	})
	.describe("Профиль пользователя")
